"use client";

import { useEffect } from 'react';

import useCognito from '../../shared/hooks/use-cognito';

export default function CognitoSignIn() {
  const { signIn } = useCognito();

  useEffect(() => {
    signIn().catch((error) => {
      console.error('Cognito sign-in failed', error);
    });
  }, [signIn]);

  return null;
}
